export default __webpack_public_path__ + "static/media/bg_login.9680ca49.png";